var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ps-component-wrapper" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.validationMsg,
                expression: "validationMsg",
              },
            ],
            staticClass: "validation--popoup",
          },
          [
            _c("p", [
              _vm._v("\n        " + _vm._s(_vm.validationMsg) + "\n      "),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _vm.cart.item_count
          ? _c(
              "form",
              {
                staticClass: "site-cart",
                attrs: { action: "/cart", method: "post", novalidate: "" },
                on: { submit: _vm.checkout },
              },
              [
                _c("div", { staticClass: "cart__header mta-center" }, [
                  _c("div", { staticClass: "cart__header-left" }, [
                    _c("h1", { staticClass: "cart__title" }, [
                      _vm._v(_vm._s(_vm.$language.cart.title)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cart__header-right tablet-up" }, [
                    _c("span", { staticClass: "cart__total-items" }, [
                      _vm._v("\n            You have "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.cart.item_count) + " products"),
                      ]),
                      _vm._v(" in your\n            cart.\n          "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "cart__total-price dta-right",
                        class: { "disabled--text": _vm.isUpdating },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$language.cart.subtotal) +
                            ":\n            "
                        ),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$money(_vm.cart.total_price))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      attrs: {
                        type: "submit",
                        name: "checkout",
                        value: "> Checkout",
                        disabled: _vm.isUpdating,
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "cart__ul" },
                  [
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.free_shipping
                        ? _c("li", { staticClass: "cart__free-shipping" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$language.cart.free_shipping) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "cart__li cart-list-header xlarge-down--hide",
                      },
                      [
                        _c("span", { staticClass: "cart__image" }, [
                          _vm._v("PHOTO"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "cart__details" }, [
                          _vm._v("DESCRIPTION"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "cart__quantity" }, [
                          _vm._v("QUANTITY"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "cart__price-single" }, [
                          _vm._v("PRICE PER 1"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "cart__price-total" }, [
                          _vm._v("TOTAL PRICE"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "cart__remove" }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "transition-group",
                      { attrs: { name: "fade", mode: "out-in" } },
                      _vm._l(_vm.cart.items, function (item, idx) {
                        return _c(
                          "li",
                          { key: item.key, staticClass: "cart__li" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "cart__image",
                                attrs: { href: item.url },
                              },
                              [
                                _c("img", {
                                  staticClass: "lazyload",
                                  attrs: { src: item.image },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "cart__details" }, [
                              _c(
                                "span",
                                { staticClass: "cart__details-title" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.product_title) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "cart__details-variant" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.variant_title) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                ref: "shortdescription",
                                refInFor: true,
                                staticClass: "cart__details-short-description",
                                class: _vm.getLineShortDescription(
                                  item.handle,
                                  idx
                                ),
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "cart__quantity" }, [
                              _c("p", { staticClass: "cart__item__label" }, [
                                _vm._v("QUANTITY"),
                              ]),
                              _vm._v(" "),
                              item.product_type == "Stair Nosing"
                                ? _c(
                                    "div",
                                    { staticClass: "item__quantity" },
                                    [
                                      item.properties && item.properties["Qty"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "quantity__stair-nosing",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.properties["Qty"])
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : item.product_type == "KitBox"
                                ? _c("div", { staticClass: "item__quantity" }, [
                                    _c(
                                      "span",
                                      { staticClass: "quantity__stair-nosing" },
                                      [_vm._v(_vm._s(item.variant_title))]
                                    ),
                                  ])
                                : _c(
                                    "div",
                                    { staticClass: "cart__quantity-toggle" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "item__quantity-minus",
                                          attrs: { disabled: _vm.isUpdating },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateQuantity(
                                                item.key,
                                                item.quantity - 1
                                              )
                                            },
                                          },
                                        },
                                        [_c("IconMinus")],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        staticClass: "item__quantity-input",
                                        attrs: {
                                          name: "updates[]",
                                          type: "text",
                                          pattern: "[0-9]*",
                                          min: "0",
                                          "aria-label": "quantity",
                                          disabled: _vm.isUpdating,
                                        },
                                        domProps: { value: item.quantity },
                                        on: {
                                          change: function ($event) {
                                            $event.preventDefault()
                                            _vm.updateQuantity(
                                              item.key,
                                              Number($event.target.value)
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "item__quantity-plus",
                                          attrs: { disabled: _vm.isUpdating },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateQuantity(
                                                item.key,
                                                item.quantity + 1
                                              )
                                            },
                                          },
                                        },
                                        [_c("IconPlus")],
                                        1
                                      ),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("span", {
                                ref: "unit",
                                refInFor: true,
                                staticClass: "cart__details-unit",
                                class: _vm.getLineUnit(item.handle, idx),
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.properties.unit) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "cart__price-single" }, [
                              _c("p", { staticClass: "cart__item__label" }, [
                                _vm._v("PRICE PER 1"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "cart__details-price",
                                  class: { "disabled--text": _vm.isUpdating },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$money(item.original_price)) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "cart__price-total" }, [
                              _c("p", { staticClass: "cart__item__label" }, [
                                _vm._v("TOTAL PRICE"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "cart__details-price",
                                  class: { "disabled--text": _vm.isUpdating },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$money(item.line_price)) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "cart__remove" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "cart__remove",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.updateQuantity(item.key, 0)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$language.cart.remove) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "cart__actions" }, [
                  _c("div", { staticClass: "cart__note" }, [
                    _c(
                      "label",
                      {
                        staticClass: "cart__note-btn",
                        attrs: { for: "cart-note" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.cart.note ? "EDIT NOTE" : "ORDER NOTES")
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cart.note,
                          expression: "cart.note",
                        },
                      ],
                      staticClass: "cart__note-textarea",
                      attrs: {
                        name: "note",
                        id: "cart-note",
                        rows: "3",
                        placeholder: _vm.$language.cart.note,
                      },
                      domProps: { value: _vm.cart.note },
                      on: {
                        keyup: function ($event) {
                          return _vm.updateNote()
                        },
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.cart, "note", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "cart__total-price mobile-down mta-center",
                      class: { "disabled--text": _vm.isUpdating },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$language.cart.subtotal) +
                          " " +
                          _vm._s(_vm.$money(_vm.cart.total_price)) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "cart__actions-btns" }, [
                    _c("input", {
                      staticClass:
                        "btn btn--primary btn--blackwash cart__checkout",
                      attrs: {
                        type: "submit",
                        name: "checkout",
                        disabled: _vm.isUpdating,
                      },
                      domProps: { value: _vm.$language.cart.checkout },
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn--whitewash",
                        attrs: { href: "/collections/all" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$language.cart.continue_browsing) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            )
          : !_vm.mini && _vm.hasBuiltCart
          ? _c("div", { staticClass: "cart__empty" }, [
              _c("p", [_vm._v(_vm._s(_vm.$language.cart.empty))]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("a", { attrs: { href: "/collections/all" } }, [
                _vm._v("Continue Shopping"),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }